
import { useState, useEffect, useRef } from 'react'
import { Button, FormControl } from '@mui/material'
import { jaJP } from '@mui/x-data-grid'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import CloseIcon from '@mui/icons-material/Close'
import { addDays, format } from 'date-fns'
import { useAuth } from './../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import ReaOnlyOutlinedInput from '../../components/input/ReaOnlyOutlinedInput'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import NumPad from '../../components/uiParts/NumPad'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm'
import BidMastaInputForm from '../../components/uiParts/bid/BidMastaInputForm'
import { dateToString, stringToDate, normarize } from '../../utils/Library'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import { fishStyleList, kgDivision } from '../../Store'
import CustomSelect from '../../components/select/CustomSelect'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CustomCheckbox from '../../components/input/CustomCheckbox'
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import UpdateIcon from '@mui/icons-material/Update'

const BidList = () => {
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - 基本情報を設定
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ contentsHeight,      setContentsHeight      ] = useState(window.innerHeight -100)
    const [ dataGridHeight,      setDataGridHeight      ] = useState(window.innerHeight -290)
    const [ containerHeight,     setContainerHeight     ] = useState(window.innerHeight -100)
    const [ dataGridWidth,       setDataGridWidth       ] = useState(window.innerWidth -480)
    const [ condition ,          setCondition           ] = useState('')
	const [ searchStatus ,       setSearchStatus        ] = useState(1)
    const [ searchCount,         setSearchCount         ] = useState(0)
    const [ targetList,          setTargetList          ] = useState('')
    const [ entryDate,           setEntryDate           ] = useState(today)
    const [ bidList,             setBidList             ] = useState([])
	const [ checkedBidList,      setCheckedBidList      ] = useState([])
    const [ openDialogShipGroup, setOpenDialogShipGroup ] = useState(false)
    const [ openDialogShip,      setOpenDialogShip      ] = useState(false)
    const [ openDialogFishSpec,  setOpenDialogFishSpec  ] = useState(false)
    const [ openDialogFishSpecDetail,  setOpenDialogFishSpecDetail  ] = useState(false)
    const [ requireMessage,      setRequireMessage      ] = useState('')
    const [ shipList,            setShipList            ] = useState([])
    const [ shipGroupList,       setShipGroupList       ] = useState([])
    const [ fishSpecList,        setFishSpecList        ] = useState([])
    const [ fishSpecDetailList,        setFishSpecDetailList        ] = useState([])
    const [ standardGroupList,       setStandardGroupList       ] = useState([])
    const [ standardList,        setStandardList        ] = useState([])
    const [ memoList,            setMemoList            ] = useState([])
    const [ openDialogStandard,  setOpenDialogStandard  ] = useState(false)
    const [ focusCell,           setFocusCell           ] = useState('')
    const [ containerList,       setContainerList       ] = useState([])
    const [ openDialogContainer, setOpenDialogContainer ] = useState(false)
    const [ openDialogFishStyle, setOpenDialogFishStyle ] = useState(false)
    const [ openDialogStandardGroup, setOpenDialogStandardGroup ] = useState(false)
    
    // 登録データ
    const [registerData, setRegisterData] = useState({
        uniqueId        : '',
        entryDate       : '',
        senmeiGroupCode : '',
        senmeiGroup     : '',
        senmei          : '',
        senmeiCode      : '',
        senmei          : '',
        gyoshuCode      : '',
        gyoshu          : '',
        kgKubun         : 1,
        nisugata        : 8,
        kikakuCode      : '',
        kikaku          : '',
        kgSuryo         : '',
        yokiCode        : '',
        yoki            : '',
        suryo           : 1,
        commentCode     : '',
        comment         : '',
        memoCode        : '',
        memo            : '',
        senbetsuFlag    : false,
        mikomiFlag      : false,
        seqNo           : '',
        displayNo       : '',
        bidStatus       : 0
    })
    // UI Message
    const [messageState, setMessageState] = useState({
        snackBarTrue  : false,
        snackBarFalse : false,
        require       : false,
    })
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const effectRan  = useRef(false)
    const senmeiRef  = useRef()
    const gyoshuRef  = useRef()
    const kikakuRef  = useRef()
    const kgSuryoRef = useRef()
    const yokiRef    = useRef()
    const suryoRef   = useRef()
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / BidList
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus
        }
        await searchData_post(postData)
    }
	//-----------------------------------------------
    // API - getNextId / BidList
	//-----------------------------------------------
    const { response : getNextId_res, post : getNextId_post } = usePost()
    const getNextId = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getNextId',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextId_post(postData)
    }
	//-----------------------------------------------
    // API - getNextId / BidList
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost()
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextNo_post(postData)
    }
	//-----------------------------------------------
    // API - setData / BidList
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost()
    const setData = async (targetData) => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'       : 'mch.models.table.BidList',
            'methodName'      : 'setDataByBidder',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : targetData.activeFlag,
            'userId'          : userId,
            'uniqueId'        : targetData.uniqueId,
            'entryDate'       : numericDate,
            'senmeiGroupCode' : targetData.senmeiGroupCode,
            'senmeiGroup'     : targetData.senmeiGroup,
            'senmei'          : targetData.senmei,
            'senmeiCode'      : targetData.senmeiCode,
            'senmei'          : targetData.senmei,
            'gyoshuCode'      : targetData.gyoshuCode,
            'gyoshu'          : targetData.gyoshu,
            'kgKubun'         : targetData.kgKubun,
            'nisugata'        : targetData.nisugata,
            'kikakuCode'      : targetData.kikakuCode,
            'kikaku'          : targetData.kikaku,
            'kgSuryo'         : targetData.kgSuryo,
            'yokiCode'        : targetData.yokiCode,
            'yoki'            : targetData.yoki,
            'suryo'           : targetData.suryo,
            'commentCode'     : targetData.commentCode,
            'comment'         : targetData.comment,
            'memoCode'        : targetData.memoCode,
            'memo'            : targetData.memo,
            'senbetsuFlag'    : targetData.senbetsuFlag ? 1 : 0,
            'mikomiFlag'      : targetData.mikomiFlag ? 1 : 0,
            'seqNo'           : targetData.seqNo,
            'displayNo'       : targetData.displayNo,
            'bidStatus'       : targetData.bidStatus
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // API - setGroupNo / BidList
	//-----------------------------------------------
    const { response : setGroupNo_res, post : setGroupNo_post } = usePost()
    const setGroupNo = async (targetUniqueId, groupNo, seqNo) => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'setGroupNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'uniqueId'     : targetUniqueId,
            'groupNo'        : groupNo,
            'seqNo'        : seqNo,
        }
        await setGroupNo_post(postData)
    }
	//-----------------------------------------------
    // API - updateDisplayNo / BidList
	//-----------------------------------------------
    const { response : updateDisplayNo_res, post : updateDisplayNo_post } = usePost()
    const updateDisplayNo = async (uniqueIdList) => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'updateDisplayNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
            'uniqueIdList' : uniqueIdList,
        }
        await updateDisplayNo_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.ShipGroup
	//-----------------------------------------------
    const { response : getDataAll_shipGroup_res, post : getDataAll_shipGroup_post } = usePost()
    const getDataAll_shipGroup = async () => {
        const postData = {
            'className'    : 'mch.models.masta.ShipGroup',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_shipGroup_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_shipGroup_res, post : getData_shipGroup_post } = usePost()
    const getData_shipGroup = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.ShipGroup',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_shipGroup_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost()
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : searchData_ship_res, post : searchData_ship_post } = usePost()
    const searchData_ship = async (senmeiGroupCode) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'groupCode'    : senmeiGroupCode
        }
        await searchData_ship_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost()
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.FishSpec
	//-----------------------------------------------
    const { response : getDataAll_fishSpec_res, post : getDataAll_fishSpec_post } = usePost()
    const getDataAll_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'searchDataByTimesNum',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.fishSpec
	//-----------------------------------------------
    const { response : searchData_fishSpec_res, post : searchData_fishSpec_post } = usePost()
    const searchData_fishSpec = async (initial) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'searchDataByInitial',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'initial'      : initial
        }
        await searchData_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : updateTimesNum_res, post : updateTimesNum_post } = usePost()
    const updateTimesNum = async (gyoshuCode) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'updateTimesNum',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : gyoshuCode,
            'activeFlag'   : 1
        }
        await updateTimesNum_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Container
	//-----------------------------------------------
    const { response : getDataAll_container_res, post : getDataAll_container_post } = usePost()
    const getDataAll_container = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_container_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Container
	//-----------------------------------------------
    const { response : getData_container_res, post : getData_container_post } = usePost()
    const getData_container = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_container_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.StandardGroup
	//-----------------------------------------------
    const { response : getDataAll_standardGroup_res, post : getDataAll_standardGroup_post } = usePost()
    const getDataAll_standardGroup = async () => {
        const postData = {
            'className'    : 'mch.models.masta.StandardGroup',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standardGroup_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getDataAll_standard_res, post : getDataAll_standard_post } = usePost()
    const getDataAll_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standard_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : searchData_standard_res, post : searchData_standard_post } = usePost()
    const searchData_standard = async (groupCode) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'groupCode'    : groupCode
        }
        await searchData_standard_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Memo
	//-----------------------------------------------
    const { response : getDataAll_memo_res, post : getDataAll_memo_post } = usePost()
    const getDataAll_memo = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_memo_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Memo
	//-----------------------------------------------
    const { response : getData_memo_res, post : getData_memo_post } = usePost()
    const getData_memo = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_memo_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
        // 初回マウント時のみ実行
        if (effectRan.current === false) {
            effectRan.current = true

            setSearchCount(searchCount+1)
    
            getDataAll_shipGroup()
            //getDataAll_ship()
            getDataAll_fishSpec()
            getDataAll_container()
            getDataAll_standardGroup()
            //getDataAll_standard()
            getDataAll_memo()
            
            senmeiRef.current.focus()
            setFocusCell('senmei')
            
            const handleResize = () => {
                setContentsHeight(window.innerHeight - 100)
                setDataGridHeight(window.innerHeight - 290)
                setContainerHeight(window.innerHeight - 100)
                setDataGridWidth(window.innerWidth - 480)
            }
            window.addEventListener('resize', handleResize)
            return () => {
                window.removeEventListener('resize', handleResize)
            }
        }
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData()
        setCheckedBidList([])
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([])
        if (searchData_res) {
            setBidList(searchData_res.Data)
        }
    }, [searchData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextId_res) {
            const targetData = { ...registerData, uniqueId: getNextId_res.uniqueId, activeFlag: 1 }
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData)
            } else {
                setMessageInfo('require', true)
            }
        }
    }, [getNextId_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateDisplayNo_res) {
            setMessageInfo('snackBarTrue', true)
            setCheckedBidList([])
            handleClick_new()
        }
    }, [updateDisplayNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            let number = 0
            checkedBidList.map(async (checkedBidListId) => {
                bidList.map((item, index) => {
                    let bidData = {}
                    if (item.id == checkedBidListId) { 
                        bidData = item
                        ++number
                        setGroupNo(bidData.uniqueId, getNextNo_res.groupNo, number)
                    }
                })
            })
        }
    }, [getNextNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            if (setData_res.statusCode == 9) {
                setRequireMessage('落札済みのため変更できません')
                setMessageInfo('require', true)
            } else if (setData_res.statusCode == 1) {
                setRequireMessage('入札が開始されているため変更できません')
                setMessageInfo('require', true)
            } else if (setData_res.statusCode == 8) {
                setRequireMessage('開票中のため変更できません')
                setMessageInfo('require', true)
            } else {
                updateTimesNum(registerData.gyoshuCode) // 魚種の利用回数をカウントアップ
    
                setMessageInfo('confirm', false)
                setMessageInfo('snackBarTrue', true)
                    
                // 船名と魚種は記憶して初期化
                setRegisterData(prevSearchData => ({
                    ...prevSearchData,
                    uniqueId     : '',
                    kgSuryo      : '',
                    kikakuCode   : '',
                    kikaku       : '',
                    kgKubun      : 1,
                    suryo        : 1,
                    yokiCode     : '',
                    yoki         : '',
                    senbetsuFlag : false,
                    mikomiFlag   : false,
                    memoCode     : '',
                    memo         : '',
                    seqNo        : '',
                    bidStatus    : 0,
                }))
                
                setSearchCount(searchCount+1)
    
                // 規格にフォーカス
                kikakuRef.current.focus()
                setFocusCell('kikaku')
            }
        }
    }, [setData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setGroupNo_res) {
            setSearchCount(searchCount+1)
            setCheckedBidList([])
            handleClick_new()

            setMessageInfo('confirm', false)
            setMessageInfo('snackBarTrue', true)
        }
    }, [setGroupNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([])
        if (getDataAll_ship_res) {
            setShipList(getDataAll_ship_res.Data)
        }
    }, [getDataAll_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([])
        if (searchData_ship_res) {
            setShipList(searchData_ship_res.Data)
            handleClick_dialog_ship()
        }
    }, [searchData_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            handleChange('senmeiGroupCode', getData_ship_res.groupCode)
            handleChange('senmeiGroup', getData_ship_res.group)
            handleChange('senmeiCode', getData_ship_res.code)
            handleChange('senmei', getData_ship_res.displayName)
        }
    }, [getData_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_shipGroup)
	//-----------------------------------------------
    useEffect(() => {
        setShipGroupList([])
        if (getDataAll_shipGroup_res) {
            setShipGroupList(getDataAll_shipGroup_res.Data)
        }
    }, [getDataAll_shipGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecList([])
        if (getDataAll_fishSpec_res) {
            setFishSpecList(getDataAll_fishSpec_res.Data)
        }
    }, [getDataAll_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecDetailList([])
        if (searchData_fishSpec_res) {
            setFishSpecDetailList(searchData_fishSpec_res.Data)
        }
    }, [searchData_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            handleChange('gyoshuCode', getData_fishSpec_res.code)
            handleChange('gyoshu', getData_fishSpec_res.displayName)
        }
    }, [getData_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_container)
	//-----------------------------------------------
    useEffect(() => {
        setContainerList([])
        if (getDataAll_container_res) {
            setContainerList(getDataAll_container_res.Data)
        }
    }, [getDataAll_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_container)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_container_res) {
            handleChange('yokiCode', getData_container_res.code)
            handleChange('yoki', getData_container_res.displayName)
        }
    }, [getData_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standardGroup)
	//-----------------------------------------------
    useEffect(() => {
        setStandardGroupList([])
        if (getDataAll_standardGroup_res) {
            setStandardGroupList(getDataAll_standardGroup_res.Data)
        }
    }, [getDataAll_standardGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([])
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data)
        }
    }, [getDataAll_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([])
        if (searchData_standard_res) {
            setStandardList(searchData_standard_res.Data)
            handleClick_dialog_standard()
        }
    }, [searchData_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            handleChange('kikakuCode', getData_standard_res.code)
            handleChange('kikaku', getData_standard_res.displayName)
        }
    }, [getData_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (openDialogStandard == false && registerData.kikaku != '') {
            kgSuryoRef.current.focus()
            setFocusCell('kgSuryo')
        }
    }, [openDialogStandard])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_memo)
	//-----------------------------------------------
    useEffect(() => {
        setMemoList([])
        if (getDataAll_memo_res) {
            setMemoList(getDataAll_memo_res.Data)
        }
    }, [getDataAll_memo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_memo)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_memo_res) {
            if (getData_memo_res.displayName) {
                handleChange('memoCode', getData_memo_res.code)
                handleChange('memo', getData_memo_res.displayName)
            } else {
                handleChange('memoCode', '')
                handleChange('memo', '')
            }
        }
    }, [getData_memo_res])
	//-----------------------------------------------
    // useEffect - dataGirdの選択
	//-----------------------------------------------
    useEffect(() => {
        if (targetList) {
            setRegisterData({ ...targetList,
                entryDate: stringToDate(targetList.entryDate),
                senbetsuFlag: targetList.senbetsuFlag ? true : false,
                mikomiFlag: targetList.mikomiFlag ? true : false,
            })
        }
    }, [targetList])
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }))
    }
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today)
        setCondition('')
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        checked ? setSearchStatus(1) : setSearchStatus('')
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - 荷主にフォーカス
	//-----------------------------------------------
    const handleClick_senmei = () => {
        setFocusCell('senmei')
    }
	//-----------------------------------------------
    // eventHandler - 魚種にフォーカス
	//-----------------------------------------------
    const handleClick_gyoshu = () => {
        setFocusCell('gyoshu')
    }
	//-----------------------------------------------
    // eventHandler - 規格にフォーカス
	//-----------------------------------------------
    const handleClick_kikaku = () => {
        setFocusCell('kikaku')
    }
	//-----------------------------------------------
    // eventHandler - 容器にフォーカス
	//-----------------------------------------------
    const handleClick_yoki = () => {
        setFocusCell('yoki')
    }
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setRegisterData({
            uniqueId        : '',
            entryDate       : '',
            senmeiGroupCode : '',
            senmeiGroup     : '',
            senmei          : '',
            senmeiCode      : '',
            senmei          : '',
            gyoshuCode      : '',
            gyoshu          : '',
            kgKubun         : 1,
            nisugata        : 8,
            kikakuCode      : '',
            kikaku          : '',
            kgSuryo         : '',
            yokiCode        : '',
            yoki            : '',
            suryo           : 1,
            memoCode        : '',
            memo            : '',
            senbetsuFlag    : false,
            mikomiFlag      : false,
            seqNo           : 1,
            displayNo       : '',
            bidStatus       : 0
        })
        senmeiRef.current.focus()
        setFocusCell('senmei')
        setCheckedBidList([])
    }
	//-----------------------------------------------
    // eventHandler - グループ登録ボタン
	//-----------------------------------------------
    const handleClick_groupNo_register = () => {
        const requireStatus = checkedGroup() // 必須項目をチェックする
        if (requireStatus) {
            getNextNo()
        } else {
            setMessageInfo('require', true)
        }
    }
	//-----------------------------------------------
    // eventHandler - グループ解除ボタン
	//-----------------------------------------------
    const handleClick_groupNo_delete = () => {
        checkedBidList.map(async (checkedBidListId) => {
            bidList.map(item => {
                let bidData = {}
                if (item.id == checkedBidListId) { 
                    bidData = item
                    setGroupNo(bidData.uniqueId, '', 1)
                }
            })
        })
    }
	//-----------------------------------------------
    // eventHandler - マスタヘルプの戻るボタン
	//-----------------------------------------------
    const handleClick_help_prev = (item) => {
        if (item == 'senmeiGroup') {
            setOpenDialogShipGroup(true)
            setOpenDialogShip(false)
            setOpenDialogFishSpec(false)
        } else if (item == 'senmei') {
            setOpenDialogShip(true)
            setOpenDialogFishSpec(false)
        } else if (item == 'fishSpec') {
            setOpenDialogFishSpec(true)
            setOpenDialogFishSpecDetail(false)
            setOpenDialogFishStyle(false)
        } else if (item == 'fishStyle') {
            setOpenDialogFishStyle(true)
            setOpenDialogStandardGroup(false)
        } else if (item == 'standardGroup') {
            setOpenDialogStandardGroup(true)
            setOpenDialogStandard(false)
        } else if (item == 'yoki') {
            
        }
    }
	//-----------------------------------------------
    // eventHandler - 船名グループヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_shipGroup = () => {
        setOpenDialogShipGroup(true)
    }
	//-----------------------------------------------
    // eventHandler - 船名グループヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_shipGroup_close = () => {
        setOpenDialogShipGroup(false)
    }
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_ship = () => {
        setOpenDialogShip(true)
    }
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_ship_close = () => {
        setOpenDialogShip(false)
    }
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec = () => {
        setOpenDialogFishSpec(true)
    }
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec_close = () => {
        setOpenDialogFishSpec(false)
    }
	//-----------------------------------------------
    // eventHandler - 魚種50音ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpecDetail = () => {
        setOpenDialogFishSpecDetail(true)
    }
	//-----------------------------------------------
    // eventHandler - 魚種50音ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpecDetail_close = () => {
        setOpenDialogFishSpecDetail(false)
    }
	//-----------------------------------------------
    // eventHandler - 容器ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_container = () => {
        setOpenDialogContainer(true)
    }
	//-----------------------------------------------
    // eventHandler - 容器ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_container_close = () => {
        setOpenDialogContainer(false)
    }
	//-----------------------------------------------
    // eventHandler - 規格グループヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_standardGroup = () => {
        setOpenDialogStandardGroup(true)
    }
	//-----------------------------------------------
    // eventHandler - 規格グループヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_standardGroup_close = () => {
        setOpenDialogStandardGroup(false)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_standard = () => {
        setOpenDialogStandard(true)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_standard_close = () => {
        setOpenDialogStandard(false)
        kgSuryoRef.current.focus()
    }
	//-----------------------------------------------
    // eventHandler - 荷姿ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle = () => {
        setOpenDialogFishStyle(true)
    }
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle_close = () => {
        setOpenDialogFishStyle(false)
        kgSuryoRef.current.focus()
    }
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const targetData = { ...registerData, activeFlag }
        // 新規の場合はuniqueIdを発行して登録処理を実行
        if (!targetData.uniqueId) {
            await getNextId()
        
        // 更新の場合は既存のuniqueIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                await setData(targetData)
            } else {
                setMessageInfo('require', true)
            }
        }
    }
	//-----------------------------------------------
    // eventHandler - メモの変更
	//-----------------------------------------------
    const handleChange_memo = (value) => {
        getData_memo(value)
    }
    const handleChange_senbetsuFlag = (checked) => {
        checked ? handleChange('senbetsuFlag', 1) : handleChange('senbetsuFlag', 0)
    }
    const handleChange_mikomiFlag = (checked) => {
        checked ? handleChange('mikomiFlag', 1) : handleChange('mikomiFlag', 0)
    }
	//-----------------------------------------------
    // eventHandler - 表示順の変更
	//-----------------------------------------------
    const handleClick_update_displayNo = () => {
        let uniqueIdStr = bidList.map(row => row.uniqueId).join('^')
        updateDisplayNo(uniqueIdStr)
    }
	//-----------------------------------------------
    // eventHandler - テンキーを操作
	//-----------------------------------------------
    const handleClick_numpad = (item) => {
        let prevVal
        let targetVal

        // ここで focusCell の値によって prevVal を設定する
        if (focusCell == 'senmei') {
            if (registerData.senmeiCode) {
                prevVal = ''
                handleChange('senmeiCode', '')
            } else {
                prevVal = registerData.senmei
            }
        } else if (focusCell == 'gyoshu') {
            if (registerData.gyoshuCode) {
                prevVal = ''
                handleChange('gyoshuCode', '')
            } else {
                prevVal = registerData.gyoshu
            }
        } else if (focusCell == 'kikaku') {
            if (registerData.kikakuCode) {
                prevVal = ''
                handleChange('kikakuCode', '')
            } else {
                prevVal = registerData.kikaku
            }
        } else if (focusCell == 'kgSuryo') {
            prevVal = registerData.kgSuryo
        } else if (focusCell == 'yoki') {
            if (registerData.yokiCode) {
                prevVal = ''
                handleChange('yokiCode', '')
            } else {
                prevVal = registerData.yoki
            }
        } else if (focusCell == 'suryo') {
            prevVal = registerData.suryo
        } else {
        }
        if (item == 'C') {
            if (focusCell == 'senmei') { handleChange('senmeiCode', '')
            } else if (focusCell == 'gyoshu') { handleChange('gyoshuCode', '')
            } else if (focusCell == 'yoki') { handleChange('yokiCode', '')
            } else if (focusCell == 'suryo') { handleChange('suryo', 1)
            } else {}
            targetVal = ''
        } else {
            targetVal = `${prevVal}${item}` 
        }

        // ここで focusCell の値によって異なる state 更新関数を呼び出す
        if (focusCell == 'senmei') {
            handleChange('senmei', targetVal)
        } else if (focusCell == 'gyoshu') {
            handleChange('gyoshu', targetVal)
        } else if (focusCell == 'kikaku') {
            handleChange('kikaku', targetVal)
        } else if (focusCell == 'kgSuryo') {
            handleChange('kgSuryo', targetVal)
        } else if (focusCell == 'yoki') {
            handleChange('yoki', targetVal)
        } else if (focusCell == 'suryo') {
            handleChange('suryo', targetVal)
        } else {}
    }
	//-----------------------------------------------
    // eventHandler - テンキーで「ENT」をクリック
	//-----------------------------------------------
    const handleClick_numpad_enter = () => {
        if (focusCell == 'senmei') {
            handleChange('senmeiCode', '')
            handleChange('senmei', '')
            getData_ship(registerData.senmei)
            gyoshuRef.current.focus()
            setFocusCell('gyoshu')
        } else if (focusCell == 'gyoshu') {
            handleChange('gyoshuCode', '')
            handleChange('gyoshu', '')
            getData_fishSpec(registerData.gyoshu)
            kikakuRef.current.focus()
            setFocusCell('kikaku')
        } else if (focusCell == 'kikaku') {
            handleChange('kikakuCode', '')
            handleChange('kikaku', '')
            getData_standard(registerData.kikaku)
            kgSuryoRef.current.focus()
            setFocusCell('kgSuryo')
        } else if (focusCell == 'kgSuryo') {
            // 数字か小数点以外の文字を削除し、小数点1桁までに正規化
            const targetNumber = String(registerData.kgSuryo)
            let normalizedValue = targetNumber.replace(/[^0-9.]/g, ''); // 数字と小数点以外を削除

            // カンマを削除
            normalizedValue = normalizedValue.replace(/,/g, '');

            // ピリオドが最初にある場合、前に0を追加
            if (normalizedValue.indexOf('.') === 0) {
                normalizedValue = '0' + normalizedValue;
            }
            // ピリオドが最後にある場合、後ろに0を追加
            if (normalizedValue.lastIndexOf('.') === normalizedValue.length - 1) {
                normalizedValue = normalizedValue + '0';
            }
            // 2つ以上のピリオドがある場合、最初のピリオド以外を削除
            const parts = normalizedValue.split('.');
            // 整数部が空の場合、0を追加
            if (!parts[1]) {
                normalizedValue= normalizedValue + '.0'
            }
            if (parts.length > 2) {
                normalizedValue = parts[0] + '.' + parts[1];
            }
            // 整数部が0の場合、0を追加
            if (parts.length === 1 && parts[0] === '') {
                normalizedValue = '0';
            }
            // 小数部が1桁以上の場合、最後の桁を削除して1桁にする
            if (parts.length === 2 && parts[1].length > 1) {
                parts[1] = parts[1].slice(0, 1);
                normalizedValue = parts.join('.');
            }
            handleChange('kgSuryo', normalizedValue)

            yokiRef.current.focus()
            setFocusCell('yoki')
            handleClick_dialog_container()
        } else if (focusCell == 'yoki') {
            handleChange('yokiCode', '')
            handleChange('yoki', '')
            getData_container(registerData.yoki)
            senmeiRef.current.focus()
            setFocusCell('senmei')
        } else if (focusCell == 'suryo') {
            senmeiRef.current.focus()
            setFocusCell('suryo')
        } else {}
    }
	//-----------------------------------------------
    // eventHandler - テンキーで「規格」をクリック
	//-----------------------------------------------
    const handleClick_numpad_kikaku = (item) => {
        getData_standard(item)
        setFocusCell('kikaku')
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - リストの見出し
	//-----------------------------------------------
    const columns = [
        { field: 'groupNo',    headerName: 'Gp',   width: 50, columnSeparatorWidth: 1, sortable:false, },
        { field: 'senmei', headerName: '荷主',    width: 100, columnSeparatorWidth: 1, sortable:false, },
        { field: 'displayGyoshu', headerName: '品名',    width: 180, columnSeparatorWidth: 1, sortable:false, },
        {
            field: 'kgKubun',
            headerName: 'Kg区分',
            width: 75, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'suryo', headerName: '数量',    width: 80, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'yoki',    headerName: '容器',  width: 80, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数',    width: 80, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'displayBiko', headerName: '備考',    width: 180, columnSeparatorWidth: 1, sortable:false, },
    ]
    const unitMapping = {
        1: 'Kg',
        0: '箱',
    }
    //-----------------------------------------------
    // dataGrid - 水揚一覧の行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row)
    }
    //-----------------------------------------------
    // dataGrid - 船名グループマスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_shipGroup = (code, displayName) => {
        handleChange('senmeiGroupCode', code)
        handleChange('senmeiGroup', displayName)
        searchData_ship(code)
        handleClick_dialog_shipGroup_close()
    }
    //-----------------------------------------------
    // dataGrid - 船名マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_ship = (code, displayName) => {
        handleChange('senmeiCode', code)
        handleChange('senmei', displayName)
        handleClick_dialog_ship_close()
        handleClick_dialog_fishSpec()
    }
    //-----------------------------------------------
    // dataGrid - 魚種マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpec = (code, displayName) => {
        handleChange('gyoshuCode', code)
        handleChange('gyoshu', displayName)
        handleClick_dialog_fishSpec_close()
        handleClick_dialog_fishSpecDetail_close()
        handleClick_dialog_fishStyle()
    }
    //-----------------------------------------------
    // dataGrid - 魚種マスタ50音ヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpecDetail = (initial) => {
        searchData_fishSpec(initial)
        handleClick_dialog_fishSpec_close()
        handleClick_dialog_fishSpecDetail()
    }
    //-----------------------------------------------
    // dataGrid - 荷姿マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishStyle = (code, displayName) => {
        handleChange('nisugata', code)
        handleClick_dialog_fishStyle_close()
        handleClick_dialog_standardGroup()
    }
    //-----------------------------------------------
    // dataGrid - 規格グループマスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_standardGroup = (code, displayName) => {
        searchData_standard(code)
        handleClick_dialog_standardGroup_close()
        handleClick_dialog_standard()
    }
    //-----------------------------------------------
    // dataGrid - 規格マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_standard = (code, displayName) => {
        handleChange('kikakuCode', code)
        handleChange('kikaku', displayName)
        handleClick_dialog_standard_close()
        handleClick_dialog_standardGroup_close()
        setFocusCell('kgSuryo')
        kgSuryoRef.current.focus()
    }
    //-----------------------------------------------
    // dataGrid - 容器マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_container = (code, displayName) => {
        handleChange('yokiCode', code)
        handleChange('yoki', displayName)
        handleClick_dialog_container_close()
    }
    //-----------------------------------------------
    // dataGrid - 表示順の制御
    //-----------------------------------------------
    const areRowsConsecutive = (selectedIndexes) => {
        for (let i = 1; i < selectedIndexes.length; i++) {
            if (selectedIndexes[i] - selectedIndexes[i - 1] !== 1) {
                return false;
            }
        }
        return true;
    }
    //-----------------------------------------------
    // dataGrid - 表示順の変更
    //-----------------------------------------------
    const moveRows = (direction) => {
        let newRows = [...bidList];
        let selectedIndexes = checkedBidList.map(selectedId => 
            newRows.findIndex(row => row.id === selectedId)).sort((a, b) => a - b)
        
        if (!areRowsConsecutive(selectedIndexes)) {
            setRequireMessage('行の移動には連続した行をチェックしてください')
            setMessageInfo('require', true)
            return;
        }
      
        if (areRowsConsecutive(selectedIndexes)) {
            if (direction === 'up' && selectedIndexes[0] > 0) {
                for (let i = 0; i < selectedIndexes.length; i++) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index - 1]] = [newRows[index - 1], newRows[index]];
                }
            } else if (direction === 'down' && selectedIndexes[selectedIndexes.length - 1] < newRows.length - 1) {
                for (let i = selectedIndexes.length - 1; i >= 0; i--) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];
                }
            }
        }
        setBidList(newRows);
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        //if (!uniqueId) errorFields.push('「伝票番号」')
        if (!registerData.senmeiCode) errorFields.push('「荷主」')
        if (!registerData.gyoshuCode) errorFields.push('「品名」')
        if (!registerData.kgSuryo) errorFields.push('「K数」')
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//-----------------------------------------------
	// Function - グループ化可能かチェックする
	//-----------------------------------------------
    const checkedGroup = () => {
        const errorFields = []

        // bidListが1件以上ある場合のみ処理を行う
        const filteredBidList = bidList.filter(item => checkedBidList.includes(item.id));
        if (filteredBidList.length > 1) {
            // bidList内の最初の指定項目を取得
            const firstSenmei   = filteredBidList[0].senmeiGroup
            const firstGyoshu   = filteredBidList[0].gyoshu
            const firstKikaku   = filteredBidList[0].kikaku
            const firstNisugata = filteredBidList[0].nisugata

            // bidList内のすべての指定項目が一致しているかチェック
            const allSenmeiMatch   = filteredBidList.every(item => item.senmeiGroup === firstSenmei)
            const allGyoshuMatch   = filteredBidList.every(item => item.gyoshu === firstGyoshu)
            const allKikakuMatch   = filteredBidList.every(item => item.kikaku === firstKikaku)
            const allNisugataMatch = filteredBidList.every(item => item.nisugata === firstNisugata)

            if (!allSenmeiMatch) errorFields.push('「荷主」')
            if (!allGyoshuMatch) errorFields.push('「魚種」')
            if (!allKikakuMatch) errorFields.push('「規格」')
            if (!allNisugataMatch) errorFields.push('「荷姿」')
        }
    
        if (errorFields.length) {
            const text = errorFields.join('') + 'が同一のものを指定してください'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }
    //===============================================
    // Css
    //===============================================
    const button_new = {
        fontSize: '18px', height:'68px', width:'80px', color:'#fff', backgroundColor:'#305496' 
    }
    const button_delete = { 
        fontSize: '18px', height:'70px', width:'80px', color:'#fff', backgroundColor:'#ff0000'
    }
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='bidList bodyContens'>
                <TitleBar title="入札明細" />
                <div style={{ display: 'flex', height: containerHeight }} className='mainContents'>
                    <div style={{ flex: 1, padding: '0px' }}>
                        <Frame classname="frame" title="入札明細検索">
                        <div style={{display:'flex'}}>
                            <div>
                            <BidSearchForm
                                targetDateId       = "bidList_targetDate"
                                targetDateValue    = { entryDate }
                                targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                keywordId          = "bidList_condition"
                                keywordValue       = { condition }
                                keywordOnChange    = { (e) => setCondition(e.target.value) }
                                handleSearch       = { () => handleClick_search() }
                                handleSearchClear  = { () => handleClick_search_clear() }
                                display_search     = {false}
                            />
                            </div>
                            <div style={{marginLeft:'20px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "入札未実施のみ"
                                />
                                </div>
                            </div>
                        </Frame>
                        <Frame classname="frame" title="入札明細一覧">
                            <div style={{display:'flex'}}>
                                <div style={{marginBottom:'0px', marginLeft:'0px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<UpdateIcon />}
                                        onClick   = {() => handleClick_update_displayNo() }
                                    >
                                    表示順更新
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick={ () => moveRows('up')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleDownIcon />}
                                        onClick={ () => moveRows('down')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginLeft:'20px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxIcon />}
                                        onClick={ () => handleClick_groupNo_register()}
                                    >{"グループ登録"}
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxOutlineBlankIcon />}
                                        onClick={ () => handleClick_groupNo_delete()}
                                    >{"グループ解除"}
                                    </Button>
                                </div>
                            </div>
                            <div style={{ flexGrow: 1, width: dataGridWidth}}>
                                <CustomDataGrid
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                    }
                                    editMode                = "row"
                                    rows                    = { bidList }
                                    columns                 = { columns }
                                    sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                    density                 = "compact"
                                    localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                    showColumnRightBorder
                                    showCellRightBorder
                                    checkboxSelection
                                    disableRowSelectionOnClick = {false}
                                    disableColumnMenu          = {true}
                                    loading                 = { searchData_Loading }
                                    onCellClick             = {(event) => handleClick_dataGrid(event)}
                                    onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedBidList(newSelectionModel) }}
                                    rowSelectionModel          = {checkedBidList}
                                />
                            </div>
                        </Frame>
                    </div>
                    <div style={{ width: '410px', padding: '0px'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px', height : contentsHeight}}>
                                <div style={{ marginRight : '10px', display : 'flex', }}>
                                    <BidMastaInputForm
                                        mastaName        = '荷主'
                                        inputRef         = { senmeiRef }
                                        inputId          = 'bidList_senmei'
                                        handleClick      = {() => handleClick_dialog_shipGroup()}
                                        nameValue        = { registerData.senmei }
                                        handleChangeName = {(e) => handleChange('senmei', e.target.value)}
                                        handleClickName  = {() => handleClick_senmei()}
                                    />
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_fishSpec()}
                                            >品名
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_gyoshu"
                                            inputRef = { gyoshuRef }
                                            label    = "品名"
                                            value    = { registerData.gyoshu }
                                            onClick  = {() => handleClick_gyoshu()}
                                            onChange = {(e) => handleChange('gyoshu', e.target.value)}
                                            width    = "215px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "userList_authority"
                                            label      = "荷姿"
                                            width      = "80px"
                                            dataList   = {fishStyleList} 
                                            selectedId = {registerData.nisugata}
                                            onChange = {(e) => handleChange('nisugata', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginRight:'10px', display:'flex', marginTop:'10px'}}>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_standardGroup()}
                                            >規格
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_kikaku"
                                            inputRef = { kikakuRef }
                                            label    = "規格"
                                            value    = { registerData.kikaku }
                                            onClick  = {() => handleClick_kikaku()}
                                            onChange = {(e) => handleChange('kikaku', e.target.value)}
                                            width    = "125px"kgSuryoRef
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_kgSuryo"
                                            inputRef = { kgSuryoRef }
                                            label    = "K数"
                                            value    = { registerData.kgSuryo }
                                            onClick  = {() => setFocusCell('kgSuryo')}
                                            onChange = {(e) => handleChange('kgSuryo', e.target.value)}
                                            width    = "85px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomCheckbox
                                            defaultChecked = { registerData.mikomiFlag }
                                            width      = "100px"
                                            onChange       = { (e) => handleChange_mikomiFlag(e.target.checked) }
                                            label          = "見込み"
                                        />
                                    </div>
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                                            onClick      = {() => handleClick_dialog_container()}
                                            >容器
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_yoki"
                                            inputRef = { yokiRef }
                                            label    = "容器"
                                            value    = { registerData.yoki }
                                            onClick  = {() => handleClick_yoki()}
                                            onChange = {(e) => handleChange('yoki', e.target.value)}
                                            width    = "125px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "bidList_kgKubun"
                                            label      = "Kg区分"
                                            width      = "85px"
                                            dataList   = {kgDivision} 
                                            selectedId = {registerData.kgKubun}
                                            onChange = {(e) => handleChange('kgKubun', e.target.value)}
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id         = "bidList_suryo"
                                            inputRef = { suryoRef }
                                            label      = "数量"
                                            width      = "80px"
                                            value    = { registerData.suryo }
                                            onClick  = {() => setFocusCell('suryo')}
                                            onChange = {(e) => handleChange('suryo', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '10px'} }>
                                    <div style={{marginLeft:'85px'}}>
                                        <CustomSelect
                                            id         = "bidList_memo"
                                            label      = "メモ"
                                            width      = "215px"
                                            dataList   = {memoList} 
                                            selectedId = {registerData.memoCode}
                                            onChange   = {(e) => handleChange_memo(e.target.value)} 
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomCheckbox
                                            defaultChecked = { registerData.senbetsuFlag }
                                            onChange       = { (e) => handleChange_senbetsuFlag(e.target.checked) }
                                            label          = "選別"
                                            width      = "100px"
                                        />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('101')}
                                                >
                                                {'大'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('102')}
                                                >
                                                {'中'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('103')}
                                                >
                                                {'小'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'53px', width:'80px', color:'#fff'}}
                                                onClick = {() => handleClick_numpad_kikaku('105')}
                                                >
                                                {'きず'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'8px'}}>
                                            <Button
                                                color   = "primary"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_new }
                                                onClick = { () => handleClick_new() }
                                            >{'新規'}
                                            </Button>
                                        </div>
                                    </div>
                                    <div style={{ width:'290px', paddingTop:'5px', marginLeft:'10px'}}>
                                    <NumPad onKeyPress = { (e) => handleClick_numpad(e) } array={['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '.', 'C']} />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div style={{display:'flex'}}>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "attention"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_delete }
                                                onClick = { () => setMessageInfo('confirm', true) }
                                            >{'削除'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'10px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'93px', color:'#fff', backgroundColor:'#808080' }}
                                                onClick = {() => handleClick_numpad_enter()}
                                                >
                                                {'ENT'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'5px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'195px', color:'#fff', backgroundColor:'#4A9DBC' }}
                                                onClick = {() => handleClick_Register('1')}
                                                >
                                                {'登録'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className='dialog_shipGroupList'>
                    <Dialog open={ openDialogShipGroup } onClose={ handleClick_dialog_shipGroup_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主グループを選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'990px', height:'650px'}}>
                            {shipGroupList.map(item => (
                                <Button
                                    color   = "fifthly"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'210px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_shipGroup(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_shipGroup_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShip } onClose={ handleClick_dialog_ship_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'990px', height:'650px'}}>
                            {shipList.map((item, index) => (
                                <Button
                                    color   = {index === 0 ? "fifthly" : "secondary"}
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'210px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_ship(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('senmeiGroup')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_ship_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecList'>
                    <Dialog open={ openDialogFishSpec } onClose={ handleClick_dialog_fishSpec_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種（TOP20・50音）を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <div>
                                {fishSpecList.map(item => (
                                    <Button
                                        color   = "secondary"
                                        size    ="large"
                                        variant ="contained"
                                        style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                        onClick = {() => handleClick_dataGrid_fishSpec(item.code, item.displayName)}
                                    >{item.displayName}
                                    </Button>
                                ))}
                            </div>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('あ')}
                            >あ</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('か')}
                            >か</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('さ')}
                            >さ</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('た')}
                            >た</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('な')}
                            >な</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('は')}
                            >は</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('ま')}
                            >ま</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('や')}
                            >や</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('ら')}
                            >ら</Button>
                            <Button
                                color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_fishSpecDetail('わ')}
                            >わ</Button>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('senmeiGroup')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpec_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecDetailList'>
                    <Dialog open={ openDialogFishSpecDetail } onClose={ handleClick_dialog_fishSpecDetail_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種(50音順)を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishSpecDetailList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishSpec(item.code, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('fishSpec')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpecDetail_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishStyleList'>
                    <Dialog open={ openDialogFishStyle } onClose={ handleClick_dialog_fishStyle_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷姿を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishStyleList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishStyle(item.id, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('fishSpec')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishStyle_close()}
                                startIcon = {<CloseIcon />}setKgKubun
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_yokiList'>
                    <Dialog open={ openDialogContainer } onClose={ handleClick_dialog_container_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="容器を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <Button
                                color   = "fifthly"
                                size    ="large"
                                variant ="contained"
                                style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_container('', '')}
                            >{'容器なし'}
                            </Button>
                            {containerList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_container(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_container_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_kikakuGroupList'>
                    <Dialog open={ openDialogStandardGroup } onClose={ handleClick_dialog_standardGroup_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="規格グループを選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <Button
                                color   = "fifthly"
                                size    ="large"
                                variant ="contained"
                                style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_standard('', '')}
                            >{'規格なし'}
                            </Button>
                            {standardGroupList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_standardGroup(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('fishStyle')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_standardGroup_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_kikakuList'>
                    <Dialog open={ openDialogStandard } onClose={ handleClick_dialog_standard_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="規格マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <Button
                                color   = "fifthly"
                                size    ="large"
                                variant ="contained"
                                style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                onClick = {() => handleClick_dataGrid_standard('', '')}
                            >{'規格なし'}
                            </Button>
                            {standardList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_standard(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('standardGroup')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_standard_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default BidList

  